export class User {
  id: number
  login_id: string
  name: string
  role: string
  email: string
  login_count: number
  last_login_at: Date
  is_active: boolean
  is_active_cache: boolean
  touan_upload_auth: boolean
  scoring_auth: boolean
  base_sheet_edit_auth: boolean
  submitted_at_edit_auth: boolean
  result_output_auth: boolean
  report_reference_auth: boolean
  scorable_course_codes: string[]
  scorable_campus_codes: string[]
  scorable_class_codes: string[]
  scorable_subject_codes: string[]
  is_password_checked: boolean = false
  is_delete_checked: boolean = false
  user_result_viewable_ranges: UserResultViewableRange[] = null
  
  constructor(user: any){
    this.id = user.id;
    this.login_id = user.login_id;
    this.name = user.name;
    this.role = user.role;
    this.email = user.email;
    this.login_count = user.login_count;
    this.last_login_at = user.last_login_at;
    this.is_active = user.is_active;
    this.is_active_cache = user.is_active;
    this.touan_upload_auth = user.touan_upload_auth;
    this.scoring_auth = user.scoring_auth;
    this.base_sheet_edit_auth = user.base_sheet_edit_auth;
    this.touan_upload_auth = user.touan_upload_auth;
    this.submitted_at_edit_auth = user.submitted_at_edit_auth;
    this.result_output_auth = user.result_output_auth;
    this.report_reference_auth = user.report_reference_auth;
    this.scorable_course_codes = user.scorable_course_codes == null ? [] : user.scorable_course_codes;
    this.scorable_campus_codes = user.scorable_campus_codes == null ? [] : user.scorable_campus_codes;
    this.scorable_class_codes = user.scorable_class_codes == null ? [] : user.scorable_class_codes;
    this.scorable_subject_codes = user.scorable_subject_codes == null ? [] : user.scorable_subject_codes;
  }
}

export class UserResultViewableRange {
  course_code: string = null
  campus_code: string = null
  class_code: string = null

  constructor(x: any = null){
    if(x == null){
      return;
    }

    this.course_code = x.course_code;
    this.campus_code = x.campus_code;
    this.class_code = x.class_code;
  }
}

export class SearchCondition {
  name: string = ""
  role: string = ""
}